const columns = [
  {
    alignHeader: 'left',
    alignColumns: 'left',
    key: 'name',
    label: 'Name',
    sortMethod: 'text',
    width: 30,
  },
  {
    alignHeader: 'left',
    alignColumns: 'left',
    key: 'email',
    label: 'Email',
    sortMethod: 'text',
    width: 40,
  },
  {
    alignHeader: 'left',
    alignColumns: 'left',
    key: 'role',
    label: 'User Role',
    width: 26,
  },
  {
    alignHeader: 'left',
    alignColumns: 'center',
    key: 'actions',
    label: 'Actions',
    width: 80,
  },
];

export default columns;
